import { PERMANENT_STORAGE_KEY } from '../components/utils';

const STORED_TOKEN_NAMES = {
  ACCESS_TOKEN: 'accessToken',
  ACCESS_EXPIRES_ON: 'accessExpiresOn',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_TYPE: 'tokenType'
}; // check values in tokenize function (requestAgent.js)

export const LAST_USER_ACTIVITY_DATE_TIME = 'lastUserActivityDateTime';

export const LAST_SELECTED_ACCOUNT_NUMBER = 'lastSelectedAccountNumber';

export const removeAccessToken = () => window.localStorage.removeItem(STORED_TOKEN_NAMES.ACCESS_TOKEN);

export const getAccessToken = () => window.localStorage.getItem(STORED_TOKEN_NAMES.ACCESS_TOKEN);

export const getRefreshToken = () => window.localStorage.getItem(STORED_TOKEN_NAMES.REFRESH_TOKEN);

export const getAccessExpiresOn = () => window.localStorage.getItem(STORED_TOKEN_NAMES.ACCESS_EXPIRES_ON);

export const getTokenType = () => window.localStorage.getItem(STORED_TOKEN_NAMES.TOKEN_TYPE);

export const clearLocalStorage = () => {
  const permanentStorage = window.localStorage.getItem(PERMANENT_STORAGE_KEY);
  window.localStorage.clear();
  window.localStorage.setItem(PERMANENT_STORAGE_KEY, permanentStorage);
};

export const isTokenValid = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const accessExpiresOn = getAccessExpiresOn();

  return accessToken && refreshToken && accessExpiresOn > Date.now();
};

export const setConfirmationActionType = (type) => localStorage.setItem('CONFIRMATION_TYPE', type);
export const setAvailableConfirmationTypes = (types) => localStorage.setItem('AVAILABLE_CONFIRMATION_TYPES', types);
export const setTimerDurationExpiresAt = (expiresAt) => localStorage.setItem('TIMER_DURATION_EXPIRES_AT', expiresAt);

export const getConfirmationActionType = () => localStorage.getItem('CONFIRMATION_TYPE');
export const getAvailableConfirmationTypes = () => localStorage.getItem('AVAILABLE_CONFIRMATION_TYPES');
export const getTimerDurationExpiresAt = () => localStorage.getItem('TIMER_DURATION_EXPIRES_AT');

export const removeConfirmationActionType = () => localStorage.removeItem('CONFIRMATION_TYPE');

export const updateConfirmationActionType = (confirmationType) => {
  const currentConfirmationType = getConfirmationActionType();
  if (!currentConfirmationType || currentConfirmationType !== confirmationType) {
    localStorage.setItem('CONFIRMATION_TYPE', confirmationType);
  }
};

export const setSecureUserPhone = (phone) => localStorage.setItem('SECURE_PHONE', phone);

export const getSecureUserPhone = () => localStorage.getItem('SECURE_PHONE');

export const saveTokenInfo = (info) =>
  Object.entries(info).map(([key, value]) => window.localStorage.setItem(key, value));

export const setLastUserActivityDateTime = () => localStorage.setItem(LAST_USER_ACTIVITY_DATE_TIME, new Date());

export const resetLastUserActivityDateTime = () => localStorage.setItem(LAST_USER_ACTIVITY_DATE_TIME, '');

export const getLastUserActivityDateTime = () => localStorage.getItem(LAST_USER_ACTIVITY_DATE_TIME);

export const setSelectedMultiAccount = (accountNumber) =>
  localStorage.setItem(LAST_SELECTED_ACCOUNT_NUMBER, accountNumber);

export const getSelectedMultiAccount = () => localStorage.getItem(LAST_SELECTED_ACCOUNT_NUMBER);

export const logoutActiveSessionWithoutToken = () => {
  window.location = '/logout';
  clearLocalStorage();
};

export const isActiveSession = () =>
  // eslint-disable-next-line max-len
  new Date() - new Date(getLastUserActivityDateTime()) < process.env.REACT_APP_PROLONGATION_MODAL_APPEARING_TIME * 1000;

export const USER_ID_INTERNAL_LOCAL_STORAGE = 'user_id_internal';
export const CUSTOMER_ID_LOCAL_STORAGE = 'customer_id';
export const CUSTOMER_TYPE_LOCAL_STORAGE = 'customer_type';

export const setIsSuccessLoginStatus = (status) => localStorage.setItem('isSuccessLogin', status);
export const setInternalUserId = (id) => localStorage.setItem(USER_ID_INTERNAL_LOCAL_STORAGE, id);
export const setCustomerId = (id) => localStorage.setItem(CUSTOMER_ID_LOCAL_STORAGE, id);
export const setCustomerType = (type) => localStorage.setItem(CUSTOMER_TYPE_LOCAL_STORAGE, type);

export const getIsSuccessLoginStatus = () => localStorage.getItem('isSuccessLogin');
export const getInternalUserId = () => localStorage.getItem(USER_ID_INTERNAL_LOCAL_STORAGE);
export const getCustomerId = () => localStorage.getItem(CUSTOMER_ID_LOCAL_STORAGE);
export const getCustomerType = () => localStorage.getItem(CUSTOMER_TYPE_LOCAL_STORAGE);

export const removeIsSuccessLoginStatus = () => localStorage.removeItem('isSuccessLogin');

export const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = (name, value, options = {}) => {
  options = {
    path: '/',
    // Default expiration to 1 year
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  for (const optionKey in options) {
    updatedCookie += `; ${optionKey}`;
    const optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += `=${optionValue}`;
    }
  }

  document.cookie = updatedCookie;
};
